import { render } from "./_summarize.vue?vue&type=template&id=7f223d58&scoped=true"
import script from "./_summarize.vue?vue&type=script&lang=js"
export * from "./_summarize.vue?vue&type=script&lang=js"

import "./_summarize.vue?vue&type=style&index=0&id=7f223d58&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f223d58"]])

export default __exports__